import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
export function CTASection() {
  return <section className="py-24 px-4 sm:px-6 lg:px-8 bg-white text-center" data-id="element-1">
      <div className="max-w-4xl mx-auto" data-id="element-2">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-3">
          <h2 className="text-4xl sm:text-5xl font-display font-bold text-charcoal-800 mb-12" data-id="element-4">
            You have two choices:
          </h2>

          <div className="grid md:grid-cols-2 gap-8 mb-16" data-id="element-5">
            <div className="bg-cream p-8 rounded-3xl border border-cream-dark text-left" data-id="element-6">
              <h3 className="text-xl font-bold text-charcoal-800 mb-4 flex items-center gap-2" data-id="element-7">
                <span className="w-8 h-8 rounded-full bg-charcoal-700/10 flex items-center justify-center text-sm" data-id="element-8">
                  A
                </span>
                Path A
              </h3>
              <p className="text-charcoal-700/80 leading-relaxed" data-id="element-9">
                Keep doing what you're doing. Keep drinking the coffee, doing
                the HIIT, and wondering why you're still tired and bloated.
              </p>
            </div>

            <div className="bg-sage-400 text-white p-8 rounded-3xl shadow-xl text-left relative overflow-hidden" data-id="element-10">
              <div className="absolute top-0 right-0 w-32 h-32 bg-white/10 rounded-bl-full" data-id="element-11"></div>
              <h3 className="text-xl font-bold mb-4 flex items-center gap-2 relative z-10" data-id="element-12">
                <span className="w-8 h-8 rounded-full bg-white/20 flex items-center justify-center text-sm" data-id="element-13">
                  B
                </span>
                Path B
              </h3>
              <p className="text-cream leading-relaxed relative z-10" data-id="element-14">
                Spend $27 (less than a lunch at Chipotle) and get the blueprint
                to finally work with your body.
              </p>
            </div>
          </div>

          <Button variant="urgent" size="xl" onClick={() => document.getElementById('pricing')?.scrollIntoView({
          behavior: 'smooth'
        })} data-id="element-15">
            YES! RESET MY CORTISOL NOW FOR $27
          </Button>
          <p className="mt-6 text-sm text-charcoal-700/60" data-id="element-16">
            Immediate Digital Access. One-time payment. No subscriptions.
          </p>
        </motion.div>
      </div>
    </section>;
}